import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import AsyncComboBox from "../../base/AsyncComboBox";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%"
    },
    paper: {
      width: "100%"
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1)
    },
    table: {
      minWidth: 500
    },
    toolbar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1)
    },
    title: {
      flex: "1 1 100%"
    },
    message: {
      marginBottom: "10px"
    },
    noBorder: {
      border: "none"
    }
  };
});
export default function ManageUsersTable(_ref) {
  var users = _ref.users,
    setUsers = _ref.setUsers,
    allowConfiguringTeams = _ref.allowConfiguringTeams;
  var classes = useStyles();
  var setTeams = function setTeams(user, teams) {
    var userClone = _objectSpread({}, user);
    userClone.teams = teams;
    var usersClone = _toConsumableArray(users);
    var index = users.indexOf(user);
    if (index >= 0) {
      usersClone[index] = userClone;
    }
    setUsers(usersClone);
  };
  var isTableEmpty = users.length === 0;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.message,
    variant: "body1"
  }, "Please select the users who can use this application"), /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    className: classes.table,
    "aria-labelledby": "Users"
  }, !isTableEmpty && /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "User Name"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "Login"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "Instance"), allowConfiguringTeams && /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, "Teams"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Authorized"))), /*#__PURE__*/React.createElement(TableBody, null, users.map(function (user, index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      hover: true,
      role: "task",
      tabIndex: -1,
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      component: "th",
      scope: "row",
      padding: "default"
    }, user.longName), /*#__PURE__*/React.createElement(TableCell, {
      align: "center",
      component: "th",
      scope: "row",
      padding: "default"
    }, user.userName), /*#__PURE__*/React.createElement(TableCell, {
      align: "center",
      component: "th",
      scope: "row",
      padding: "default"
    }, user.instanceName), allowConfiguringTeams && /*#__PURE__*/React.createElement(TableCell, {
      align: "center",
      component: "th",
      scope: "row",
      padding: "default"
    }, /*#__PURE__*/React.createElement(AsyncComboBox, {
      url: "cloudapi/configuration/teams",
      textFieldProps: {
        label: "",
        fullWidth: true,
        size: "small",
        style: {
          minWidth: "200px",
          marginTop: 0,
          marginBottom: 0,
          borderColor: "red"
        }
      },
      value: user.teams || [],
      onChange: function onChange(event, value) {
        return setTeams(user, value);
      },
      freeSolo: true,
      multiple: true,
      autoSelect: false
    })), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      component: "th",
      scope: "row",
      padding: "default"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      color: "primary",
      checked: user.selected,
      onChange: function onChange(event) {
        var updatedUser = _objectSpread({}, user);
        updatedUser.selected = event.target.checked;
        var updatedUsers = _toConsumableArray(users);
        updatedUsers.splice(index, 1, updatedUser);
        setUsers(updatedUsers);
      }
    })));
  }), isTableEmpty && /*#__PURE__*/React.createElement(TableRow, {
    style: {
      height: 53
    }
  }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    color: "textSecondary"
  }, "No users"))))))));
}